/**
 * Les mentions que le signataire accepte avant de signer — **citées verbatim** : les deux premières
 * du prototype validé (`mocks/ghp-ct`, écran « Signature ») et du CDC, le consentement de la frame
 * Terrain 1.10b (M37).
 *
 * ⚠️ **Une seule source, trois lecteurs** : la tablette les lit au signataire, l'éditeur du bureau
 * les montre au valideur, le rapport PDF les imprime au client. C'est l'archive de ce qui a été
 * accepté — une reformulation, même meilleure, changerait ce qu'il a signé.
 *
 * ⚠️ **Elles vivent ici parce qu'une copie a déjà dérivé.** Le premier rapport PDF (#236) imprimait
 * « certifie avoir rendu accessibles… » là où le signataire avait lu « certifie nous avoir montré et
 * rendu accessible… » : trois copies, et le document livré était le seul faux.
 */
export const CERTIFICATION_MENTIONS = {
    certifiedWaterPoints: 'Le signataire certifie nous avoir montré et rendu accessible tous les points d’eau du bâtiment.',
    certifiedNoSepticTank: 'Le signataire confirme l’absence de fosse.',
    /**
     * ⚠️ **Formulation provisoire** (M37) : celle de la frame, en attendant l'accord de GHP sur le
     * texte. La corriger avant le premier contrôle réel — après, ce serait changer ce qu'un
     * signataire a accepté.
     */
    consentedDataRetention: 'J’accepte que mes données soient conservées dans le cadre du contrôle',
};
//# sourceMappingURL=certification.js.map